import { all, fork } from "redux-saga/effects";
import userSaga from "./user.saga";
import leadsSaga from "./leads.saga";

export default function* rootSaga() {
  yield all([fork(userSaga), fork(leadsSaga)]);
}
